var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1628 2.20184H35.2787V0H9.96094V59.0755H12.1628V2.20184Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4805 0V2.20184H62.7982V19.4675H65.0001V0H37.4805Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7983 61.0565H51.0567V72.7982H27.0596V75H52.6137L65.0002 62.6135V21.6688H62.7983V61.0565ZM53.2585 71.2418V63.2584H61.2419L53.2585 71.2418Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1628 61.2769H9.96094V75H24.8583V72.7982H12.1628V61.2769Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8318 34.4914H41.5169V5.87085H15.8318V34.4914ZM34.9119 32.2895H22.4367V27.2261C22.4367 24.8961 23.7082 22.8047 25.7275 21.7266C26.5395 22.3664 27.5626 22.7497 28.6743 22.7497C29.7856 22.7497 30.8087 22.3664 31.6206 21.7266C33.6405 22.8047 34.9119 24.8961 34.9119 27.2261V32.2895ZM26.1057 17.9793V16.5116C26.1057 15.0954 27.2581 13.9435 28.6743 13.9435C30.0906 13.9435 31.243 15.0954 31.243 16.5116V17.9793C31.243 19.3955 30.0906 20.5479 28.6743 20.5479C27.2581 20.5479 26.1057 19.3955 26.1057 17.9793ZM18.0336 8.07269H39.3151V32.2895H37.1138V27.2261C37.1138 24.2077 35.5362 21.4852 33.0036 19.9791C33.2857 19.3703 33.4442 18.6934 33.4442 17.9793V16.5116C33.4442 13.8817 31.3042 11.7417 28.6743 11.7417C26.0439 11.7417 23.9044 13.8817 23.9044 16.5116V17.9793C23.9044 18.6934 24.063 19.3703 24.345 19.9791C21.8125 21.4852 20.2349 24.2077 20.2349 27.2261V32.2895H18.0336V8.07269Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8553 7.3385V11.008H45.1858V17.6124H48.8553V21.282H55.4597V17.6124H59.1293V11.008H55.4597V7.3385H48.8553ZM56.9274 13.2093V15.4112H53.2585V19.0801H51.0566V15.4112H47.3876V13.2093H51.0566V9.54034H53.2585V13.2093H56.9274Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2141 49.4127H42.6172V51.6146H38.2141V49.4127Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8191 49.4127H55.093V51.6146H44.8191V49.4127Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2065 49.4127H36.0128V51.6146H27.2065V49.4127Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8682 49.4127H25.0048V51.6146H19.8682V49.4127Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.085 44.5204H55.093V46.7222H44.085V44.5204Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8682 44.5204H33.0775V46.7222H19.8682V44.5204Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2787 44.5204H37.4805V46.7222H35.2787V44.5204Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6819 44.5204H41.8837V46.7222H39.6819V44.5204Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8682 39.6281H27.2067V41.8299H19.8682V39.6281Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.408 39.6281H47.0204V41.8299H29.408V39.6281Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2222 39.6281H55.093V41.8299H49.2222V39.6281Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2787 54.3051H37.4805V56.5069H35.2787V54.3051Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8682 54.3051H33.0775V56.5069H19.8682V54.3051Z",
    fill: "#82C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6819 54.3051H41.8837V56.5069H39.6819V54.3051Z",
    fill: "#82C3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddPatient);
export default __webpack_public_path__ + "static/media/icon_addPatient.9a9e408445fed9a0afd237cfb7dfb49d.svg";
export { ForwardRef as ReactComponent };